// gle theme entry. Imports register custom elements with the browser
// the first time the module is evaluated. Order doesn't matter —
// each define() is independent.

import '//glereadytowear.com/cdn/shop/t/12/assets/gle-quantity.js?v=14277168713239394781780564401';
import '//glereadytowear.com/cdn/shop/t/12/assets/gle-nav.js?v=57184030869047375381780564401';
import '//glereadytowear.com/cdn/shop/t/12/assets/gle-search.js?v=73038925698823290971780590831';
import '//glereadytowear.com/cdn/shop/t/12/assets/gle-cart.js?v=160559968085342883341780575524';
import '//glereadytowear.com/cdn/shop/t/12/assets/gle-variant-picker.js?v=152076081993726645511780564402';
import '//glereadytowear.com/cdn/shop/t/12/assets/gle-collection-filters.js?v=40585988821290120711780574426';

// Customizer support: scroll a freshly-selected section into view.
document.addEventListener('shopify:section:select', (event) => {
  event.target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
